import {
    forwardRef,
    Inject,
    NgModule,
    Optional
} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {
    Potion,
    POTION_PROVIDER,
    POTION_RESOURCES,
    PotionResources
} from './potion';
/**
 * Provide a way to register Potion resources when the app is bootstrapped.
 * 
 * \@example 
 * // app.resources.ts
 * import {PotionResources, PotionModule} from 'potion-client/\@angular';
 * export const appResources: PotionResources = {
 *     '/engine': Engine,
 * 	   '/car': [Car, {
 * 	       readonly: ['production']
 * 	   }]
 * };
 * 
 * // app.module.ts
 * import {AppComponent} from './app.component'
 * import {resources} from './app.resources';
 * \@NgModule({ 
 *     imports: [PotionModule],
 *     bootstrap: [AppComponent],
 *     providers: [
 *         {
 *             provide: POTION_RESOURCES,
 *             useValue: resources,
 *             multi: true
 *         }
 *     ]
 * }
 * export class AppModule {}
 */
export class PotionModule {
/**
 * @param {?} potion
 * @param {?} resources
 */
constructor(
         potion: Potion,
          resources: PotionResources[]
    ) {
        potion.registerFromProvider(resources || []);
    }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [HttpClientModule],
    providers: [
        POTION_PROVIDER
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Potion, decorators: [{ type: Inject, args: [forwardRef(() => Potion), ] }, ]},
{type: Array, decorators: [{ type: Optional }, { type: Inject, args: [POTION_RESOURCES, ] }, ]},
];
}

function PotionModule_tsickle_Closure_declarations() {
/** @type {?} */
PotionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PotionModule.ctorParameters;
}



export {POTION_RESOURCES,PotionResources,POTION_CONFIG,PotionConfig,Potion,POTION_PROVIDER_FACTORY,POTION_PROVIDER} from './potion';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
